// extracted by mini-css-extract-plugin
export default {"preview":"Signature_preview__wnapn","footer-buttons":"Signature_footer-buttons__b-z7t"};